import { css } from "@emotion/react";
import { useState } from "react";
import { Button } from "../Button/Button";
import { TextField } from "../TextField";
import { CSVImportUIRenderSearchFieldProps } from "./CSVImportUI";

interface CSVImportUISearchScreenProps<Row> {
  searchLabel?: string;
  renderData: (data: Row[]) => React.JSX.Element;
  onSearch?: (args: { value: string }) => Promise<{
    data: Row[];
  }>;
  onDownloadTemplate: (data: Row[]) => void;
  renderSearchField?: (
    props: CSVImportUIRenderSearchFieldProps<Row>,
  ) => React.JSX.Element;
}

export const CSVImportUISearchScreen = <Row extends Record<string, string>>({
  searchLabel,
  renderData,
  onSearch,
  onDownloadTemplate,
  renderSearchField: RenderSearchField,
}: CSVImportUISearchScreenProps<Row>) => {
  const [data, setData] = useState<Row[]>([]);

  return (
    <div
      css={css`
        display: grid;
        gap: 16px;
      `}
    >
      {RenderSearchField ? (
        <RenderSearchField onChange={setData} />
      ) : (
        <div
          css={css`
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
          `}
        >
          <form
            onSubmit={async (event) => {
              event.preventDefault();

              const formData = new FormData(event.target as HTMLFormElement);

              if (onSearch === undefined) {
                throw new Error(
                  "CSVImportUI: In update mode, onSearchData is required",
                );
              }

              const { data } = await onSearch({
                value: formData.get("value") as string,
              });

              setData(data);
            }}
          >
            <div
              css={css`
                display: flex;
                gap: 8px;
                align-items: flex-end;
              `}
            >
              <TextField label={searchLabel} name="value" />

              <Button type="submit" variant="outlined">
                検索
              </Button>
            </div>
          </form>
        </div>
      )}

      {renderData(data)}

      <div
        css={css`
          display: flex;
          justify-content: flex-end;
        `}
      >
        <Button
          disabled={data.length === 0}
          variant="filled"
          color="primary"
          onClick={() => {
            onDownloadTemplate(data);
          }}
        >
          更新用CSVをダウンロード
        </Button>
      </div>
    </div>
  );
};
